export default __webpack_public_path__ + "static/media/sportsbra-medium-right.a7b5e532.jpg";